import { useState } from "react";
import { toast } from "sonner";
import { Check, Loader2, X } from "lucide-react";
import { ownerApi, apiErrorText } from "@/lib/ownerApi";

export default function SongEditForm({ song, index, onSaved, onCancel }) {
  const [title, setTitle] = useState(song.title);
  const [artist, setArtist] = useState(song.artist || "");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (!title.trim()) return toast.error("Please enter a song title.");
    setSaving(true);
    try {
      const { data } = await ownerApi.patch(`/admin/music/${song.id}`, { title, artist });
      onSaved(data);
      toast.success("Song details saved.");
    } catch (err) {
      toast.error(apiErrorText(err));
      setSaving(false);
    }
  };

  const field = "w-full rounded-lg bg-[rgba(245,240,232,0.06)] border border-[rgba(197,165,90,0.25)] px-2.5 py-1.5 text-sm text-[#F5F0E8] placeholder:text-[#A0988E]/60 focus:outline-none focus:border-[#D4AF37]";

  return (
    <form onSubmit={save} data-testid={`owner-song-edit-form-${index}`} className="flex-1 space-y-1.5 py-1">
      <input data-testid={`owner-song-title-input-${index}`} value={title} onChange={(e) => setTitle(e.target.value)} maxLength={120}
             placeholder="Song title" aria-label="Song title" className={field} autoFocus />
      <input data-testid={`owner-song-artist-input-${index}`} value={artist} onChange={(e) => setArtist(e.target.value)} maxLength={120}
             placeholder="Artist (optional)" aria-label="Artist" className={field} />
      <div className="flex gap-2 justify-end">
        <button type="button" data-testid={`owner-song-edit-cancel-${index}`} onClick={onCancel} className="text-xs text-[#A0988E] hover:text-[#F5F0E8] inline-flex items-center gap-1 px-2 py-1">
          <X size={12} /> Cancel
        </button>
        <button type="submit" data-testid={`owner-song-edit-save-${index}`} disabled={saving} className="btn-primary text-xs py-1 px-3 disabled:opacity-60">
          {saving ? <Loader2 size={12} className="animate-spin" /> : <Check size={12} />} Save
        </button>
      </div>
    </form>
  );
}
